import { validateLoginEmail, type LoginErrorCode } from "./login-form.ts";

export type LoginState = {
  step: "email" | "password";
  email: string;
  password: string;
  error: LoginErrorCode | null;
  showPassword: boolean;
  submitting: boolean;
};

export type LoginAction =
  | { type: "email" | "password"; value: string }
  | { type: "next" | "back" | "togglePassword" | "submit" }
  | { type: "failed"; error: LoginErrorCode };

export const initialLoginState: LoginState = {
  step: "email", email: "", password: "", error: null, showPassword: false, submitting: false,
};

export function loginReducer(state: LoginState, action: LoginAction): LoginState {
  if (state.submitting && action.type !== "failed") return state;

  switch (action.type) {
    case "email":
      return { ...state, email: action.value, error: null };
    case "password":
      return { ...state, password: action.value, error: null };
    case "next": {
      if (state.step !== "email") return state;
      const email = validateLoginEmail(state.email);
      return email.ok
        ? { ...initialLoginState, step: "password", email: email.email }
        : { ...state, error: "invalidEmail" };
    }
    case "back":
      return { ...initialLoginState, email: state.email };
    case "togglePassword":
      return { ...state, showPassword: !state.showPassword };
    case "submit":
      if (state.step !== "password") return state;
      if (!state.password.trim()) return { ...state, error: "missingPassword" };
      return { ...state, submitting: true, error: null };
    case "failed":
      return { ...state, submitting: false, error: action.error };
  }
}
